<template>
  <v-simple-table dense>
    <template #default>
      <tbody>
        <tr v-for="(step, index) in steps" :key="step.name">
          <td style="width: 40px">{{ index + 1 }}</td>
          <td style="width: 40px"><v-icon small :color="colorOf(step)">{{ iconOf(step) }}</v-icon></td>
          <td>
            {{ stepName(step) }}
            <!-- Un échec porte sa raison et ses valeurs : c'est ce qui dit quoi corriger. -->
            <div v-if="step.reason" class="text-caption red--text">{{ reasonOf(step) }}</div>
          </td>
          <td class="text-right text-caption text--secondary" style="white-space: nowrap">{{ step.executedAt | formatDate }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { planReason, planStepName } from './planLabels'
/** Les gestes d'un plan, avant ou après leur exécution : la même liste dans les deux cas. */
export default {
  name: 'PlanSteps',

  props: {
    steps: { type: Array, required: true },
  },

  methods: {

    stepName(step) {
      return planStepName(this, step)
    },

    reasonOf(step) {
      return planReason(this, step.reason, step.reasonParameters, step.reasonLabel)
    },

    iconOf(step) {
      if (step.outcome === 'done') return 'mdi-check-circle'
      if (step.outcome === 'already-done') return 'mdi-check-circle-outline'
      if (step.outcome === 'failed') return 'mdi-alert-circle'
      return 'mdi-circle-outline'
    },

    colorOf(step) {
      if (step.outcome === 'done') return 'green'
      if (step.outcome === 'already-done') return 'blue-grey'
      if (step.outcome === 'failed') return 'red'
      return 'grey lighten-1'
    },
  },
}
</script>
